// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__pu1lI","tableResponsive":"ClientDetail_tableResponsive__64DUt"};